import ListSubheader from '@mui/material/ListSubheader';
import React from 'react';

export type QMenuSubheaderProps = {
  label: string;
  /** When true, subheader sticks while scrolling the menu. Default false (MUI `disableSticky`). */
  sticky?: boolean;
};

export function QMenuSubheader({ label, sticky = false }: QMenuSubheaderProps): React.ReactElement {
  return (
    <ListSubheader
      disableSticky={!sticky}
      sx={{
        typography: 'captionRegular',
        color: 'text.secondary',
        py: 0.25,
        px: 1,
        bgcolor: 'transparent',
      }}
    >
      {label}
    </ListSubheader>
  );
}

// MenuList skips a child when `child.type.muiSkipListHighlight` is set (MUI ListSubheader
// does this). Wrappers must re-expose it or the subheader is treated as the active item,
// autoFocus/tabIndex are discarded, and arrow keys never reach a row.
QMenuSubheader.muiSkipListHighlight = true;
